// Tablesaw - (repsonsive tables)

import 'tablesaw/dist/tablesaw.jquery.js';
import 'tablesaw/dist/tablesaw.css';

export function initTablesaw() {
    (<any>window).Tablesaw.init();
}